// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2LWwE","footer":"ModalInfo_footer__1V99a"};